const POST_LOGIN_KEY = "superAdminPostLoginRedirect";

export function isSafeSuperAdminPath(path) {
  if (typeof path !== "string" || !path.startsWith("/super-admin")) return false;
  if (path.startsWith("//")) return false;
  return !/^https?:/i.test(path);
}

export function buildSuperAdminLoginPath(returnTo = "/super-admin/dashboard") {
  const safe = isSafeSuperAdminPath(returnTo) ? returnTo : "/super-admin/dashboard";
  return `/super-admin/login?returnTo=${encodeURIComponent(safe)}`;
}

export function setSuperAdminPostLoginRedirect(path) {
  if (isSafeSuperAdminPath(path)) {
    sessionStorage.setItem(POST_LOGIN_KEY, path);
  }
}

export function clearSuperAdminPostLoginRedirect() {
  sessionStorage.removeItem(POST_LOGIN_KEY);
}

export function resolveSuperAdminPostLoginRedirect(location) {
  const fromQuery = new URLSearchParams(location?.search || "").get("returnTo");
  const fromStorage = sessionStorage.getItem(POST_LOGIN_KEY);
  return [fromQuery, fromStorage].find(isSafeSuperAdminPath) || "/super-admin/dashboard";
}
